import { ITemplateMailRepository } from "domain/contracts/template-mail.contract";
import { TemplateMail } from "domain/entities/template-mail";
import { TemplateMailInputFilter } from "domain/models/template-mail-input-filter";
import { httpClient } from "../axios/axios-api";
import { Message } from "domain/entities/message";

class TemplateMailRepository implements ITemplateMailRepository {
  async getAll(
    filter: TemplateMailInputFilter
  ): Promise<Message<TemplateMail[]>> {
    const response = await httpClient.get(`/templateMail`, { params: filter });
    return response.data;
  }

  async getById(id: string): Promise<Message<TemplateMail>> {
    const response = await httpClient.get(`/templateMail/${id}`);
    return response.data;
  }

  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/templateMail/${id}`);
    return response.data;
  }

  async create(input: TemplateMail): Promise<Message<TemplateMail>> {
    const response = await httpClient.post(`/templateMail`, { data: input });
    return response.data;
  }

  async update(input: TemplateMail): Promise<Message<boolean>> {
    const response = await httpClient.put(`/templateMail/${input.id}`, {
      data: input,
    });
    return response.data;
  }
}

export default new TemplateMailRepository();
